import img from "@/assets/maintanace-bg.png";

export const MaintenancePage = () => {
  return (
    <div
      style={{ backgroundImage: `url(${img})` }}
      className="flex h-screen w-screen flex-col items-center justify-center bg-cover bg-center p-8 text-center"
    >
      <h1 className="mb-4 rounded-3xl bg-secondary-50 p-4 subtitle">
        System Update In Progress
      </h1>
      <h2 className="mb-12 text-6xl font-medium text-accent-900 capitalize lg:text-8xl">
        We'll be back soon
      </h2>
      <p className="mb-2">We are currently undergoing scheduled maintenance.</p>
      <p>Thank you for your patience - please check back shortly.</p>
    </div>
  );
};
